<template>
  <div
    class="password-reset"
    data-test="password-reset">
    <loader v-show="!data_loaded"/>
    <div v-show="data_loaded">
      <div class="m-b-3">
        <div v-if="!showThankyou">
          <h4 class="t-c m-b font-normal">Password Reset</h4>
          <p class="t-c m-b-2">Enter Your New Password Below</p>
          <el-form
            ref="changePasswordForm"
            :model="changePassword"
            :rules="changePasswordValidationRules">
            <el-form-item
              label="New Password"
              prop="new_password"
              class="">
              <el-input
                v-model="changePassword.new_password"
                type="password"
                placeholder="8+ characters, including 1 number"
                auto-complete="off"
                data-test="new-password"
                @keyup.native="checkValidation"/>
            </el-form-item>
            <el-form-item
              label="Confirm password"
              prop="confirm_password"
              class="">
              <el-input
                v-model="changePassword.confirm_password"
                type="password"
                auto-complete="off"
                data-test="confirm-password"
                @keyup.native="checkValidation"/>
            </el-form-item>
            <div class="t-c">
              <el-button
                v-loading="saving_data"
                :disabled="!form_valid"
                class="button large"
                type="primary"
                data-test="submit"
                @click="onSubmit">Submit</el-button>
            </div>
          </el-form>
        </div>
        <div
          v-if="showThankyou"
          class="t-c thank-you-section">
          <p data-test="thank-you-section">Your password has been successfully updated.</p>
          <el-button
            type="primary"
            class="button large"
            @click="redirectToSignIn">Log In</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '../components/Loader';
import User from '../services/User';
import PageMixin from '../shared/pageMixin';

export default {
  components: { Loader },
  mixins: [PageMixin],
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Confirm password required'));
      } else if (value !== this.changePassword.new_password) {
        callback(new Error('Passwords do not match'));
      } else {
        callback();
      }
    };
    const passwordStrength = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Password Required'));
      } else {
        const strongRegex = new RegExp(
          '^(?=.*[a-z])(?=.*[0-9])(?=.{8,})',
        );
        if (strongRegex.test(value)) {
          callback();
        } else {
          callback(new Error('Weak Password Strength (8+ characters, including 1 number)'));
        }
      }
    };
    return {
      pageName: 'Reset Password',
      userProvider: new User(),
      data_loaded: false,
      saving_data: false,
      showThankyou: false,
      form_valid: false,
      changePassword: {
        new_password: '',
        confirm_password: '',
      },
      changePasswordValidationRules: {
        new_password: [
          { required: true, validator: passwordStrength, trigger: 'blur' },
        ],
        confirm_password: [
          { required: true, validator: validatePass2, trigger: 'blur' },
        ],
      },
    };
  },
  mounted() {
    this.data_loaded = true;
  },
  methods: {
    onSubmit() {
      this.$refs.changePasswordForm.validate((valid) => {
        if (valid) {
          this.resetPassword();
        }
      });
    },
    resetPassword() {
      this.loading = true;
      const urlParams = new URLSearchParams(window.location.search);
      const oobCode = urlParams.get('oobCode');
      this.userProvider.resetPassword(oobCode, this.changePassword.confirm_password)
        .then(() => {
          this.loading = false;
          this.showSuccessMsg('Reset password');
          this.showThankyou = true;
        })
        .catch((error) => {
          this.loading = false;
          this.showErrorMsg(error);
        });
    },
    redirectToSignIn() {
      this.$router.push('/signin');
    },
    checkValidation() {
      if (this.changePassword.new_password.length && this.changePassword.confirm_password.length) {
        this.$refs.changePasswordForm.validate((valid) => { this.form_valid = valid; });
      }
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/variables.scss";

.password-reset{
  max-width: 349px;
  width: 90%;
  margin: auto;
  margin-top: 80px;
  h4 {
    font-family: $clearface-bold;
    color: $black;
    font-size: 40px;
    letter-spacing: -1px;
    line-height: 44px;
    margin: 46px 0 8px 0;
  }
  .el-form{
    .el-form-item{
      margin-bottom: 16px;
      .el-form-item__label{
        color: #111111;
        font-size: 16px;
        line-height: 28px;
      }
      .el-form-item__label:before{
        content: none !important;
      }
      .el-input{
        .el-input__inner{
          height: 48px;
          border-radius: 8px;
        }
      }
    }
  }
  .title{
    margin: 0px !important;
    margin-bottom: 24px !important;
    font-size: 24px !important;
    font-weight: normal !important;
    line-height: 28px;
    color: #111111;
  }
  .el-button{
    min-width: 110px;
    margin-top: 16px;
  }
  .el-button.el-button--default{
    min-width: 110px;
    background-color: #bbbbbb;
    border-color: inherit;
    color: #ffffff;
    margin-top: 16px;
  }
  .thank-you-section {
    margin-top: 100px;
    > div{
      color: #bbbbbb;
    }
    .title{
      margin-bottom: 18px !important;
    }
  }
}

.el-form-item__error{
  margin: 0px;
}
@media (max-width: 1024px) {
  .password-reset{
    max-width: 414px;
    width: 414px;
  }
}
@media (max-width: 768px) {
  .password-reset{
    max-width: 378px;
    width: 378px;
  }
}
@media (max-width: 567px) {
  .password-reset{
    max-width: 311px;
    width: 311px;
    margin: auto;
    margin-top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/ResetPassword.vue